import { RouterProvider } from "react-router-dom";
import { router } from "routes";

import './assets/styles/app.css';

const App = () => {
  return <RouterProvider router={router} />;
};

export default App;
